import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./TicketNumbers.css";
import * as actionTypes from "../../store/actions";

const TicketNumbers = (props) => {

  /* const [offset, setOffset] = useState(8); */
  const ref = useRef(null)
  const numRef = useRef(null)

  useEffect(() => {
    /* console.log(ref.current.scrollLeft, "ref")
    console.log(numRef.current.offsetLeft, "numRef") */
    if (ref && numRef) {
      ref.current.scrollTo({
        left: numRef.current.offsetLeft - 60,
        behavior: "smooth",
      });
    }
  }, [ref, numRef, props.tasks, props.paramsTaskId]);

  const resetAnswerClickedId = () => {
    props.setClickedAnswerId(null);
  };

  const classHandler = (taskId, ticketId) => {
    if (props.categoryTickets.substr(0, 4) !== "exam" && props.categoryTickets.substr(0, 3) !== "new")  {
      const filtered = props.numbersStateArray.find(
        (item) => item.id === taskId
      );
      if (filtered !== undefined) {
        if (filtered.isError === true && filtered.id === taskId) {
          return "red non-pointer ";
        } else if (filtered.isError === false && filtered.id === taskId) {
          return "green non-pointer ";
        } else return "";
      }
    } else {
      const filtered = props.numbersStateArray.find(
        (item) => item.taskId === taskId && item.ticketId === ticketId
      );
      if (filtered !== undefined) {
        if (filtered.isError === true && filtered.taskId === taskId) {
          return "red non-pointer ";
        } else if (filtered.isError === false && filtered.taskId === taskId) {
          return "green non-pointer ";
        } else return "";
      }
    }
    return "";
  };

  /*  ref={props.paramsTaskId === task.taskId ? numRef : null} */

  if (props.categoryTickets.substr(0, 4) === "exam" || props.categoryTickets.substr(0, 3) === "new") {
    return (
      <div ref={ref} className="numbers">
        {props.tasks.map((task, index) => (
          <Link
            ref={parseInt(props.paramsTaskId) === index + 1 ? numRef : null}
            onClick={resetAnswerClickedId}
            key={index}
            className={
              "number " +
              (parseInt(props.paramsTaskId) === index + 1 ? "active " : "") +
              classHandler(task.taskId, task.ticketId)
            }
            to={`/${props.categoryTickets}/${index + 1}/`}
          >
            {index + 1}
          </Link>
        ))}
      </div>
    );
  } 
  else {
    return (
      <div ref={ref} className="numbers">
        {props.tasks.map((task) => (
          <Link
            ref={props.paramsTaskId === task.taskId ? numRef : null}
            onClick={resetAnswerClickedId}
            key={task.taskId}
            className={
              "number " +
              (props.paramsTaskId === task.taskId ? "active " : "") +
              classHandler(task.taskId)
            }
            to={`/${props.categoryTickets}/${props.ticketId}/${task.taskId}/`}
          >
            {task.taskId}
          </Link>
        ))}
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketNumbers);
